// extracted by mini-css-extract-plugin
module.exports = {"favorite-artists":"favorite-artists_favorite-artists__5jpYE"};